import React from 'react';
import {
  DashboardOutlined,
  FormOutlined,
  LayoutOutlined,
  TableOutlined,
  UserOutlined,
  BlockOutlined,
  FileImageOutlined,
  BellOutlined,
  MenuOutlined,
  InfoCircleOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import { UserRole } from '@app/utils/role.utils';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  allowedRoles?: UserRole | UserRole[]; // Roles that can see this menu item
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'common.dashboard',
    key: 'dashboard',
    url: '/',
    icon: <DashboardOutlined />,
  },
  {
    title: 'common.news',
    key: 'news',
    icon: <FormOutlined />,
    children: [
      {
        title: 'common.newsList',
        key: 'news-list',
        url: '/news/list',
      },
      {
        title: 'common.createNews',
        key: 'news-create',
        url: '/news/create',
        allowedRoles: ['admin', 'editor', 'author'],
      },
    ],
  },
  {
    title: 'common.blog',
    key: 'blog',
    icon: <FormOutlined />,
    children: [
      {
        title: 'common.blogList',
        key: 'blog-list',
        url: '/blog/list',
      },
      {
        title: 'common.createBlog',
        key: 'blog-create',
        url: '/blog/create',
        allowedRoles: ['admin', 'editor', 'author'],
      },
    ],
  },
  {
    title: 'common.pages',
    key: 'pages',
    icon: <LayoutOutlined />,
    children: [
      {
        title: 'common.pagesList',
        key: 'pages-list',
        url: '/pages/list',
      },
      {
        title: 'common.createPage',
        key: 'pages-create',
        url: '/pages/create',
        allowedRoles: ['admin', 'editor'],
      },
    ],
  },
  {
    title: 'common.menus',
    key: 'menus',
    icon: <MenuOutlined />,
    allowedRoles: ['admin', 'editor'],
    children: [
      {
        title: 'common.menusList',
        key: 'menus-list',
        url: '/menus/list',
      },
      {
        title: 'common.createMenu',
        key: 'menus-create',
        url: '/menus/create',
        allowedRoles: ['admin', 'editor'],
      },
    ],
  },
  {
    title: 'common.sliders',
    key: 'sliders',
    icon: <BlockOutlined />,
    children: [
      {
        title: 'common.slidersList',
        key: 'sliders-list',
        url: '/sliders/list',
      },
      {
        title: 'common.createSlider',
        key: 'sliders-create',
        url: '/sliders/create',
        allowedRoles: ['admin', 'editor'],
      },
    ],
  },
  {
    title: 'common.announcements',
    key: 'announcements',
    icon: <BellOutlined />,
    children: [
      {
        title: 'common.announcementsList',
        key: 'announcements-list',
        url: '/announcements/list',
      },
      {
        title: 'common.createAnnouncement',
        key: 'announcements-create',
        url: '/announcements/create',
        allowedRoles: ['admin', 'editor'],
      },
    ],
  },
  {
    title: 'common.media',
    key: 'media',
    icon: <FileImageOutlined />,
    url: '/media/library',
  },
  {
    title: 'common.users',
    key: 'users',
    icon: <UserOutlined />,
    allowedRoles: ['admin', 'editor'],
    children: [
      {
        title: 'common.usersList',
        key: 'users-list',
        url: '/users/list',
        allowedRoles: ['admin', 'editor'],
      },
      {
        title: 'common.createUser',
        key: 'users-create',
        url: '/users/create',
        allowedRoles: ['admin'],
      },
    ],
  },
  {
    title: 'common.activityLogs',
    key: 'activity-logs',
    icon: <TableOutlined />,
    url: '/activity-logs/list',
    allowedRoles: ['admin', 'editor'],
  },
  {
    title: 'common.museumInfo',
    key: 'museum-info',
    icon: <InfoCircleOutlined />,
    url: '/museum-info',
    allowedRoles: ['admin', 'editor'],
  },
  {
    title: 'common.homeContent',
    key: 'home-content',
    icon: <HomeOutlined />,
    url: '/home-content',
    allowedRoles: ['admin', 'editor'],
  },
];
